import { z } from 'zod';

export const forgottenPasswordSchema = z.object({
  email: z.string().min(1, 'components.form.validation.required').email('components.form.validation.email'),
});

export type ForgottenPasswordFormValues = z.infer<typeof forgottenPasswordSchema>;
